import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/3d.png'
import _imports_1 from '@/assets/image/redchilunbi.png'


const _withScopeId = n => (_pushScopeId("data-v-352941f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "design" }
const _hoisted_2 = { class: "day" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "imgbox" }
const _hoisted_9 = ["src", "onClick"]
const _hoisted_10 = {
  key: 1,
  src: _imports_0,
  alt: "",
  class: "title3d"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "money" }
const _hoisted_13 = { class: "number" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_15 = { class: "click" }
const _hoisted_16 = { class: "look" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "function" }
const _hoisted_19 = { class: "xingxing" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont i2",
  style: {"z-index":"200"}
}, "", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: "edit"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "edit-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-shuoming" })
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tips" }, "是否删除？", -1))
const _hoisted_28 = { class: "edit-footer" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "day2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "到底了,仅展示最近30天的记录~")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goodslist, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "timeone",
        key: index
      }, [
        _createElementVNode("div", _hoisted_2, [
          (index + '' == _ctx.now)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "今天"))
            : _createCommentVNode("", true),
          (index + '' == _ctx.yesterday)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "昨天"))
            : _createCommentVNode("", true),
          (index + '' != _ctx.now && index + '' != _ctx.yesterday)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(index), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (items, indexs) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "works",
              key: indexs,
              onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.leaving && _ctx.leaving(...args))),
              onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.leaving1 && _ctx.leaving1(...args)))
            }, [
              (_ctx.step == 2)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "workes",
                    onClick: ($event: any) => (_ctx.chessCheck(index, indexs))
                  }, null, 8, _hoisted_7))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                (_ctx.step == 2)
                  ? (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: 0,
                      modelValue: _ctx.goodslist[index][indexs].isselect,
                      "onUpdate:modelValue": ($event: any) => ((_ctx.goodslist[index][indexs].isselect) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("img", {
                    src: _ctx.getImgUrl(items.photo),
                    alt: "",
                    onClick: ($event: any) => (_ctx.goGoods(items.id)),
                    class: "photo"
                  }, null, 8, _hoisted_9)
                ]),
                (_ctx.step != 2)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "name",
                  onClick: ($event: any) => (_ctx.goGoods(items.id))
                }, _toDisplayString(items.names), 9, _hoisted_11),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", null, _toDisplayString(items.price), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(items.click) + "次浏览", 1),
                  _createElementVNode("i", {
                    class: "iconfont",
                    onClick: _withModifiers(($event: any) => (_ctx.addcard(index, indexs)), ["stop"])
                  }, "", 8, _hoisted_17)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    (
										_ctx.step != 2 && items.isselect == false && items.store == 0
									)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: "iconfont i1",
                          onClick: _withModifiers(($event: any) => (_ctx.addstore(index, indexs, 1)), ["stop"]),
                          style: {"z-index":"200"}
                        }, "", 8, _hoisted_20))
                      : _createCommentVNode("", true),
                    (
										_ctx.step != 2 && items.isselect == false && items.store == 1
									)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 1,
                          onClick: _withModifiers(($event: any) => (_ctx.addstore(index, indexs, 0)), ["stop"]),
                          class: "iconfont i1",
                          style: {"color":"#fbb113","z-index":"200"}
                        }, "", 8, _hoisted_21))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.step != 2 && items.isselect == false)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "del",
                        onClick: _withModifiers(($event: any) => (_ctx.del(index, indexs)), ["stop"])
                      }, _hoisted_24, 8, _hoisted_22))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.step != 2 && items.isselect)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _hoisted_26,
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", {
                        class: "left",
                        onClick: ($event: any) => (_ctx.delfoot(index, indexs))
                      }, "确定", 8, _hoisted_29),
                      _createElementVNode("div", {
                        class: "right",
                        onClick: ($event: any) => (_ctx.cancel(index, indexs))
                      }, "取消", 8, _hoisted_30)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 32))
          }), 128))
        ])
      ]))
    }), 128)),
    _hoisted_31
  ]))
}